import { ActionTypeEnum } from '../enums';
import { IActionConfig } from '../types';
import { ActionConfigManager } from './action-config.manager';

export class ActionsManager<TEntity, TComponentType = unknown, TData = unknown> {
  configs: ActionConfigManager<TEntity, TComponentType, TData>[];
  menuConfigs: ActionConfigManager<TEntity, TComponentType, TData>[];

  private constructor(configs: IActionConfig<TEntity, TComponentType, TData>[]) {
    this.configs = configs.map(ActionConfigManager.create);
    this.menuConfigs = this.configs.filter((x) => x.isItemAction && x.canUse());
  }

  static create<TEntity, TComponentType = unknown, TData = unknown>(
    configs: IActionConfig<TEntity, TComponentType, TData>[]
  ) {
    return new ActionsManager(configs);
  }

  execute(type: ActionTypeEnum, item?: TEntity, onClose?: () => void) {
    this.ensureHasConfig(type).execute(item, undefined, onClose);
  }

  canUse(type: ActionTypeEnum | string): boolean {
    return this.hasConfig(type) && this.ensureHasConfig(type).canUse();
  }

  canUseAny() {
    return this.configs.length > 0 && this.configs.some((x) => x.canUse());
  }

  getConfig(actionType: ActionTypeEnum | string): ActionConfigManager<TEntity, TComponentType, TData> | undefined {
    let test = this.configs.filter((x) => x.config.type === actionType)[0];
    return test as ActionConfigManager<TEntity, TComponentType, TData> | undefined;
  }

  private ensureHasConfig(type: ActionTypeEnum | string): ActionConfigManager<TEntity, TComponentType, TData> {
    if (!this.hasConfig(type)) {
      throw new Error(`Their is no config provided with this type ${type}`);
    }
    return this.getConfig(type)!;
  }

  private hasConfig(type: ActionTypeEnum | string): boolean {
    return !!this.getConfig(type);
  }
}
